import { BasicDocument } from './document.interface';
import { Picture } from './picture.interface';
import { RepairMessageText } from './repair-message-text.interface';
import { User } from './user.interface';
import { marker as _ } from '@bling-fe/shared/utils';
import {
  Base64String,
  FileKeyUploadParams,
  FileUploadParams
} from './file.interface';

export interface RepairMessage {
  id: number;
  availability: string;
  category: string;
  email: string;
  created_at: string;
  item: string;
  status: 'open' | 'closed' | 'in_progress' | 'work_done';
  texts: RepairMessageText[];
  seen: boolean;
  user: User;
  description?: string;
  pictures: Array<Picture>;
  documents?: BasicDocument[];
  property_number: number | null;
  responsible_id: number | null;
  ticket_type: TicketType;
  chat_disabled?: boolean;
  area?: RepairMessageArea | null;
  area_title?: string | null;
  category_icon_url?: string | null;
}

export type RepairMessageArea = 'apartment' | 'building' | 'settlement';

export interface RepairMessageAreaOption {
  key: string;
  value: number;
  title: string;
  picture_url: string | null;
  rental_object_type_ids?: number[];
}

export interface RepairMessageCategory {
  id: number;
  name: string;
  ticket_type: TicketType;
  available_to_inactive_members?: boolean;
  areas?: number[];
  picture_url?: string | null;
  photo_url?: string | null;
  items: RepairMessageCategoryItem[];
}

export interface RepairMessageCategoryWithParent extends RepairMessageCategory {
  parent_category: RepairMessageCategory;
}

export interface RepairMessageCategoryParams {
  ticket_type: TicketType;
}

export interface RepairMessageCancelParams {
  cancellation_reason?: string;
}

export interface RepairMessageCategoryItem {
  id: number;
  name: string;
  ticket_type: TicketType;
  areas?: number[];
  picture_url?: string | null;
  photo_url?: string | null;
}

/******
 * Websocket interfaces
 ******/

export type WS_RepairMessage =
  | Ws_RepairMessage_NewStatus
  | Ws_RepairMessage_NewMessage;

export interface Ws_RepairMessage_NewStatus {
  type: 'status_update';
  new_status: 'open' | 'closed' | 'in_progress' | 'work_done';
}

export interface Ws_RepairMessage_NewMessage {
  type: 'new_message';
  new_repair_message_text: RepairMessageText;
}

export type TicketType =
  | 'general'
  | 'repair'
  | 'space_request'
  | 'specific_request';

interface TicketTypeInfo {
  icon: string;
  title: string;
}

export const ticketTypeInfo = new Map<TicketType, TicketTypeInfo>([
  [
    'repair',
    {
      title: _('PAGES.MY_TENANT.TICKET.REPAIR'),
      icon: 'repair'
    }
  ],
  [
    'general',
    {
      title: _('PAGES.MY_TENANT.TICKET.GENERAL'),
      icon: 'envelope'
    }
  ]
]);

/*
 * RepairMessageParams – permitted params for update/create
 *
 */
export interface RepairMessageParams {
  category: string;
  item: string;
  description: string;
  email: string;
  phone: string;
  availability: string;
  property_number?: string;
  ticket_type: TicketType;
  texts?: {
    id: string;
    seen: boolean;
  };
  pictures: Base64String[];
  documents?: RepairMessageDocumentParams[];
}

export type RepairMessageDocumentParams =
  | BasicDocument
  | FileUploadParams
  | FileKeyUploadParams;

export interface RepairMessageQueryParams {
  ticket_type: TicketType;
}
